import { Component, Input, Output, EventEmitter }       from '@angular/core';

@Component({
  selector: 'pm-badge',
  //templateUrl: './app/controls/components/badge/badge.html',
  templateUrl: './badge.html',  
})
export class BadgeComponent {
  
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/badge/badge-component.ts